import {FAVORITE_ADDRESS_TUTORIAL_STAGES, getTutorialStepConfig} from '../constants';
import type {FavoriteAddressTutorialStep, FavoriteAddressTutorialStage} from '../types';

export function getStageForStep(step: FavoriteAddressTutorialStep): FavoriteAddressTutorialStage {
	return getTutorialStepConfig(step)?.stage ?? FAVORITE_ADDRESS_TUTORIAL_STAGES.COMPLETED;
}
